import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store';
import * as styles from './styles.module.scss';

const NoWebRTC: React.FC = () => {
  const logoSrc = useSelector(
    (state: StoreState) => state.branding.partnerLogoSrc || '',
  );

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <img alt='Logo' className={styles.logo} src={logoSrc} />
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_smaller}>
              Your browser does not support WebRTC
            </h2>
            <div className={styles.form_body}>
              You can find out more about which browsers do support WebRTC{' '}
              <a
                href='http://caniuse.com/#feat=rtcpeerconnection'
                target='_blank'
                className={styles.link}
                rel='noreferrer'
              >
                here
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoWebRTC;
